import dynamic from 'next/dynamic';
const ForceDecksBlogsCarousel = dynamic(() => import('./ForceDecksBlogsCarousel'));
export default ForceDecksBlogsCarousel;
